import { Link } from 'react-router-dom';

import Card from './components/Card';
import NewPlanCard from '../../../../components/NewPlanCard';

import { Container } from './styles';

const CurrentPlan = ({ plan }) => {
  return (
    <Container>
      <div className="current-plan__title">Plano atual</div>
      {/* <Card plan={plan} /> */}
      <NewPlanCard plan={plan.plan_type} />
      <div className="current-plan__change-plan-container">
        <Link to="/alterar-plano">
          <span>Alterar </span>
          plano
        </Link>
      </div>
    </Container>
  );
};

export default CurrentPlan;
<Container></Container>;
